import React from "react";
import SaveBtn from "../../../common/SaveBtn";
import { toast } from "react-toastify";

const FormContainer = (props) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    props.onSubmit();
  };

  return (
    <>
      <div
        id="mrpformcontainer"
        style={{
          maxHeight: "calc(100vh - 315px)",
          overflowY: "scroll",
        }}
      >
        {props.children}
      </div>
      <div
        className=" bg-default  border-top w-100"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          zIndex: "999",
        }}
      >
        <div className="p-3 d-flex align-items-center justify-content-around w-100">
          <p className="custom-p mt-3 d-flex align-self-center">
            <strong>Pensez à enregistrer vos modifications</strong>
          </p>
          <SaveBtn
            text="Enregistrer mes réponses"
            save={handleSubmit}
            isSaving={props.isSaving}
          />
        </div>
      </div>
    </>
  );
};

export default FormContainer;
